import Vue from 'vue'
import Vuex from 'vuex'
import loading from './modulos/loading'
import loginuser from './modulos/loginuser'
import axios from 'axios'
import nav from '../_nav'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        recarregar: false,
        requestErro: '',
        mensagens: {
            qtdMensagensNaoLidas: 0
        }
    },

    mutations: {

        UPDATE_RECARREGAR(state, status) {
            state.recarregar = status
        },

        SET_REQUEST_ERROR(state, error) {
            state.requestErro = error
        },
        
        SET_QTD_MENSAGENS_NAO_LIDAS(state, quantidade) {
            state.mensagens.qtdMensagensNaoLidas = quantidade
            // Atualiza o badge diretamente no menu
            const mensagensItem = nav.items.find(item => item.name === 'Mensagens')
            if (mensagensItem && mensagensItem.badge) {
                mensagensItem.badge.text = String(quantidade || '')
            }
        }
    },

    actions: {

        setRecarregar({ commit }, status) {
            commit('UPDATE_RECARREGAR', status)
        },

        setRequestError({ commit }, error) {
            commit('SET_REQUEST_ERROR', error)
        },

        verificarVersao() {
            axios.get('app/versao.txt', {
                headers: {
                    'Cache-Control': 'no-cache'
                }
            }).then((res) => {
                let versaoLida = res.data.replace(/[^a-zA-Z0-9.\-]/g, '')
                if (process.env.VUE_APP_VERSION != versaoLida) {
                    console.log("Versão do app: " + process.env.VUE_APP_VERSION + " | Versão do servidor: " + versaoLida)
                    window.location.reload();
                }
            });
        }
    },

    getters: {

        recarregar(state) {
            return state.recarregar
        },

        requestErro(state) {
            return state.requestErro
        },
    },

    modules: {
        loading,
        loginuser
    }
})
